import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { QualificationSection } from '../components/QualificationSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { AboutSection } from '../components/AboutSection';
import { LocationsSection } from '../components/LocationsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-213">
      <Header data-id="element-214" />
      <main data-id="element-215">
        <HeroSection data-id="element-216" />
        <TrustBar data-id="element-217" />
        <QualificationSection data-id="element-218" />
        <ServicesSection data-id="element-219" />
        <ProcessSection data-id="element-220" />
        <AboutSection data-id="element-221" />
        <LocationsSection data-id="element-222" />
        <FAQSection data-id="element-223" />
        <CTASection data-id="element-224" />
      </main>
      <Footer data-id="element-225" />
    </div>;
}